export default __webpack_public_path__ + "static/media/plenitude.0f47428d.svg";